import { Navigate } from "react-router-dom";

/**
 * Thematic listing landing page — redirects to the unified products catalog
 * with the Thematic filter pre-applied (mirrors the dane
 * `thematic-products/page.tsx`). Wire at route path `/thematic`.
 */
export function ThematicProductsPage() {
  return <Navigate to="/products?category=thematic" replace />;
}
